"use strict"
const siteHeader = document.getElementById("site-header");
const announcement = document.querySelector("announcement-bar");
const siteHeaderContainer = document.querySelector(".site-header-container");
const announcementBar = document.querySelector('announcement-bar');
const siteHeaderHeight = siteHeader.getBoundingClientRect().height;

window.addEventListener("load", (event) => {
    console.info(
        `%c Optimum7 Scripts Initialized`,
        'color: #FFF; background:#ff9800;line-height:1.5;font-family:sans-serif;font-size:16px;font-weight:700;padding:6px 10px',
    );

    if (window.innerWidth < 750) {
        siteHeaderContainer.style.marginTop = `${announcementBar ? siteHeaderHeight - 7 : (siteHeaderHeight < 189 ? 189 : siteHeaderHeight)}px`;
    } else {
        siteHeaderContainer.style.marginTop = `${siteHeaderHeight < 189 ? 189 : siteHeaderHeight}px`;
    }

    siteHeader.style.position = "fixed";
    siteHeader.style.width = "100%";
    siteHeader.style.top = "40.5px";
    siteHeader.style.transition = "top 250ms ease"
})

window.addEventListener('scroll', function() {
    if (window.scrollY > 25) {
        siteHeaderContainer.classList.add('fixed');
        siteHeader.style.top = "0";
        siteHeader.querySelector(".header__top").style.paddingTop = "15px";
        siteHeader.querySelector(".header__top").style.paddingBottom = "15px";
        siteHeader.querySelector(".header__bottom").style.paddingTop = "8px";
        siteHeader.querySelector(".header__bottom").style.paddingBottom = "8px";
    } else {
        siteHeaderContainer.classList.remove('fixed');
        siteHeader.style.top = "40.5px";
        siteHeader.querySelector(".header__top ").style.paddingTop = "var(--header-vertical-space)";
        siteHeader.querySelector(".header__top ").style.paddingBottom = "var(--header-vertical-space)";
        siteHeader.querySelector(".header__bottom").style.paddingTop = "calc(var(--header-vertical-space) / 2)";
        siteHeader.querySelector(".header__bottom").style.paddingBottom = "calc(var(--header-vertical-space) / 2)";
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash;

    if (hash) {
        const targetElement = document.querySelector(hash);

        if (targetElement) {
            setTimeout(() => {
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - 400;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }, 500)
        }
    }

});

window.isFormSubmitted = false;

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (node.matches('form') || node.querySelector('form'))) {
                const form = node.matches('form') ? node : node.querySelector('form');

                form.addEventListener('submit', function(event) {
                    window.isFormSubmitted = true;
                });
            }
        });
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

document.addEventListener('click', function(event) {
    if (event.target.matches('button')) {
        let parent = event.target.closest('.ais-RangeInput');

        if (parent) {
            const detailsElement = event.target.closest('details.js-filter');
            if (detailsElement) {
                setTimeout(() => {
                    if (window.isFormSubmitted) {
                        detailsElement.removeAttribute('open');
                        window.isFormSubmitted = false;
                    }
                }, 50)
            }
        }
    }

    if (event.target.classList.contains('js-facet-remove')) {
        let parent = event.target.closest('.ais-RangeInput');

        if (parent) {
            const detailsElement = event.target.closest('details.js-filter');
            if (detailsElement) {
                detailsElement.removeAttribute('open');
            }
        }
    }
});